import {Strings} from 'Strings';
import {stripeLib} from 'services/AsyncJSLoader';
import {AuthenticationSvc} from '../../services/AuthenticationSvc';
// import {UpgradeOneProjectSvc} from '../../services/upgradeOneProjectSvc';
import {TranslateSvc} from '../../services/TranslateSvc';
import {TypeformSvc} from '../services/TypeformSvc';
import BillingPeriod = anm.BillingPeriod;
import {AnalyticSvc} from '../../services/AnalyticSvc';
import {Utils} from '../../underscore-extensions';
import {APPLY_COUPON, CouponCompaniesNames, SubscriptionSvc} from '../services/SubscriptionSvc';
import {PREDICT_PRICE_ERROR} from '../subscription/containers/SubscriptionPredictPriceContainer';
import {SubscriptionMessagesSvc} from '../subscription/messages/SubscriptionMessagesSvc';

export interface UpgradeModal {
    chosen: boolean;
}

type SubscriptionsParamsModal =
    'editCard'
    | 'upgrade'
    | 'thank-you'
    | 'cancel'
    | 'sorry-to-see-you-go'
    | 'downgrade'
    | 'switch-period'
    | '';

export interface SubscriptionsParams extends ng.ui.IStateParamsService {
    period?: string;
    redeem?: boolean;
    plan?: string;
    coupon?: string;
    special?: string;
    modal?: SubscriptionsParamsModal;
}

interface SubscriptionsScope extends ng.IScope {
    billing?: { period: string };
}

export const SUBSCRIPTION_OPEN_MODAL = 'website/subscription/openModal';

export class SubscriptionCtrl {
    responseError: string;
    planName: string;
    subscriptionPredictPrice: anm.SubscriptionDetails;
    upgradedTo: string;
    cardDetails: anm.CardDetails;
    isRedeem = this.$state.params.redeem;
    cbUpgradeResult: Function = angular.noop;
    loading = false;
    upgradeAction: anm.UpgradeAction;
    confirmDowngradeShown = false;
    cancelModalShown = false;
    isChangeCard = false;
    upgradeResultShown = false;
    changeBillingShowNext = false;
    downgradeResultShown = false;
    upgradeProjectResultShown = false;
    cardEditSuccessShown = false;
    billingChangeSuccessShown = false;
    changeBillingShown = false;
    showEditCard = false;
    productName: string;
    cardDetailsErrorMessage: string;
    couponCompanyName: string;
    loadingDetails: boolean;
    showDetails: boolean;
    subscriptionDetails: anm.SubscriptionDetails;
    isFree: boolean;
    isHigh: boolean;
    isSpecial: boolean;
    isAppSumo: boolean;
    isStripe = () => this.subscriptionSvc.isStripe();

    mapSpecialUpgrades = {
        'small-agency': 'WaveSmallAgency',
        agency: 'WaveBigAgency',
    };

    getStarterPricing = {
        monthlyPrice: 600,
        annualPrice: 6000
    };

    private clearOpenModalListener = _.noop;
    private clearPredictPriceErrorListener = _.noop;

    constructor(private $scope: SubscriptionsScope,
                private $q: ng.IQService,
                private $state: ng.ui.IStateService,
                private $stateParams: SubscriptionsParams,
                private $rootScope: ng.IRootScopeService,
                private AuthenticationSvc: AuthenticationSvc,
                private subscriptionMessageSvc: SubscriptionMessagesSvc,
                private analyticSvc: AnalyticSvc,
                // private upgradeOneProjectSvc: UpgradeOneProjectSvc,
                private typeformSvc: TypeformSvc,
                private subscriptionSvc: SubscriptionSvc,
                private TranslateSvc: TranslateSvc) {
        this.productName = Utils.getProduct() === 'WAVE' ? 'Wave.video' : 'Studio';

        if (/typeform/.test(document.referrer)) {
            this.subscriptionSvc.showSubscriptionCanceledMessage();
        }
        this.trackVisit();
        this.updateSubscriptionDetails();

        if (this.subscriptionSvc.cardDetailsCashed) {
            this.showDetails = this.isStripe();
            this.cardDetails = this.subscriptionSvc.cardDetailsCashed;
        } else if (this.subscriptionSvc.cardDetailsErrorMessage) {
            this.cardDetailsErrorMessage = this.subscriptionSvc.cardDetailsErrorMessage;
        } else {
            this.setCardDetails();
        }

        this.subscriptionSvc.setUpgradesDiscount();
        this.openModal();
        stripeLib().then(() => window.Stripe.setPublishableKey(options.user.stripeKey()));

        this.setBillingPeriodScope();

        this.clearPredictPriceErrorListener = this.$rootScope.$on(PREDICT_PRICE_ERROR, (e, errorMessage: string) => this.responseError = errorMessage);
        this.clearOpenModalListener = this.$rootScope.$on(
            SUBSCRIPTION_OPEN_MODAL,
            (e, {modal, ...params}: SubscriptionsParams) => this.changeModalUrl(modal, params)
        );
    }

    $onDestroy() {
        this.clearOpenModalListener();
        this.clearPredictPriceErrorListener();
    }

    processResponse = (httpResponse: ng.IHttpPromiseCallbackArg<anm.SubscriptionChange | ApiError>): ng.IPromise<anm.SubscriptionChange> => {
        const deferred = this.$q.defer();
        const response = httpResponse.data;

        if (Utils.isApiError(response)) {
            const errorMsg = this.errorResponse(response);
            deferred.reject(errorMsg);
        } else {
            this.successResponse().then(() => deferred.resolve(response));
        }
        return deferred.promise;
    }

    stopLoading = () => this.loading = false;

    get upgrades() {
        return this.$stateParams.special ? this.getSpecialUpgrades() : this.subscriptionSvc.getUpgrades();
    }

    private setBillingPeriodScope() {
        const {period} = this.$stateParams;
        const currentPeriod = period && period.toLowerCase() === 'annual'
            ? 'ANNUAL'
            : 'MONTHLY';

        this.$scope.billing = {period: currentPeriod};
    }

    applyCoupon(coupon: string) {
        this.responseError = '';
        this.subscriptionMessageSvc.hideMassage();
        this.$rootScope.$emit(APPLY_COUPON, coupon);
        this.$state.go(this.$state.current, {coupon}, {notify: false});
    }

    goTo(url: string) {
        const product = Utils.getProduct().toLocaleLowerCase();
        this.$state.go(`${product}-${url}`);
    }

    trackVisit() {
        if (!this.$stateParams.modal) {
            this.analyticSvc.visitPage('Subscription');
        }
    }

    getBillingPrice(price: number, isRound = true) {
        const newPrice = price * this.subscriptionSvc.calcDiscount(this.subscriptionSvc.upgradesDiscount) / 100.0;
        return isRound ? Math.ceil(newPrice) : newPrice;
    }

    getBillingSaving(upgrade: anm.SubscriptionDetails) {
        const monthly = this.getBillingPrice(upgrade.monthlyPrice, false);
        const annual = this.getBillingPrice(upgrade.annualPrice, false);
        const save = monthly * 12 - annual;
        const saveFixed = Number((save).toFixed(2));

        return Math.ceil(saveFixed);
    }

    isPriceShown() {
        const period = this.subscriptionDetails.billingPeriod.toLowerCase();
        return period === 'coupon' || options.user.isStripe();
    }

    showUpgradeModal(upgrade: anm.SubscriptionDetails, billingPeriod: anm.BillingPeriod) {
        this.changeModalUrl('upgrade', {plan: upgrade.displayName, period: billingPeriod.toLowerCase()})
    }

    getFree() {
        const free = {
            wave: {
                name: 'WaveFree',
                displayName: 'WaveFree'
            },
            studio: {
                name: 'Free',
                displayName: 'Free'
            }
        };
        return free[this.subscriptionSvc.product.toLowerCase()]
    }

    getError(error?: string | StripeError): string {
        return this.subscriptionSvc.getError(error);
    }

    showChangeCardView() {
        this.isChangeCard = true;
        this.responseError = null;
    }

    errorResponse(response?: ApiError & StripeTokenResponse | any) {
        this.responseError = '';
        if (!response) return true;
        const error = this.getError(response.error || response.errorMessage);
        if (error) {
            this.loading = false;
            this.responseError = error;
        } else {
            return false;
        }
        return error;
    }

    successResponse() {
        this.AuthenticationSvc.notifyUserChange();
        return this.setCardDetails()
            .then(() => this.AuthenticationSvc.updateUser())
            .then(() => this.updateSubscriptionDetails())
            .finally(() => this.stopLoading());
    }

    setCardDetails() {
        this.loadingDetails = true;
        return this.subscriptionSvc.getCardDetails()
            .then((response: anm.CardDetails) => {
                this.showDetails = this.isStripe();
                this.cardDetails = response;
            })
            .catch((errorMessage) => this.cardDetailsErrorMessage = errorMessage)
            .finally(() => {
                this.loadingDetails = false;
                this.loading = false;
            });
    }

    changeSubscription(params: anm.ChangeSubscriptionRequest): ng.IPromise<anm.SubscriptionChange> {
        this.loading = true;
        return this.subscriptionSvc
            .changeSubscription(params)
            .then(this.processResponse)
            .finally(this.stopLoading);
    }

    upgradeSubscription(params: anm.ChangeSubscriptionRequest, action: anm.UpgradeAction = 'upgrade') {
        const {displayName, billingPeriod} = this.subscriptionDetails;

        return this.changeSubscription(params).then(response => {
            if (this.changeBillingShown) {
                this.changeBillingPeriodRequestHandler(billingPeriod);
            } else {
                this.upgradedTo = response.displayName;

                this.analyticSvc.changeSubscription(
                    action,
                    displayName,
                    billingPeriod,
                    this.upgradedTo,
                    response.billingPeriod,
                    response.chargedAmount / 100.0,
                    params.couponCode
                );

                this.toggleUpgradeModal();
                this.addTransaction();
                action === 'upgrade' ? this.toggleUpgradeResultModal() : this.toggleDowngradeResultModal();
            }

        });
    }

    upgradeWithToken(name: string,
                     period: BillingPeriod,
                     couponCode = '',
                     upgradeModal: UpgradeModal,
                     action?: anm.UpgradeAction): void {
        this.upgradeSubscription({name, period, couponCode}, action)
            .then(() => {
                if (upgradeModal) {
                    upgradeModal.chosen = false;
                }
            });
    }

    // upgradeProject(period: string,
    //                projectId: string,
    //                token: string,
    //                name: string,
    //                couponCode: string,
    //                upgradeModal: UpgradeModal) {
    //     this.loading = true;
    //
    //     return this.upgradeOneProjectSvc.upgrade(period, projectId, token, name, couponCode)
    //         .then(() => {
    //             this.upgradedTo = period;
    //             if (upgradeModal) {
    //                 upgradeModal.chosen = false;
    //             }
    //             this.toggleUpgradeProjectResultModal();
    //         })
    //         .finally(this.stopLoading.bind(this));
    // };

    cancelSubscription() {
        this.loading = true;

        this.subscriptionSvc.cancelSubscription()
            .then(() => this.goDefaultState())
            .then(() => this.typeformSvc.openTypeFormCancel())
            .finally(() => this.loading = false);
    }

    changeBillingPeriod(period: anm.BillingPeriod, couponCode = '') {
        const currentSubscription = this.subscriptionDetails.name;
        const oldPeriod = this.subscriptionDetails.billingPeriod;

        return this.changeSubscription({period, name: currentSubscription, couponCode})
            .then(() => this.changeBillingPeriodRequestHandler(oldPeriod));
    }

    updateCard(token: string) {
        this.loading = true;
        return this.subscriptionSvc
            .updateCard(token)
            .then(this.processResponse)
            .then(() => {
                this.showEditCard = false;
                this.cardEditSuccessShown = true;
            })
            .finally(this.stopLoading);
    }

    isEmailCorrect = () => /^.+@.+$/.test(options.user.email);

    getAlternativePeriod = () => this.isMonthly() ? 'annual' : 'monthly';

    showEditCardDetails() {
        this.changeModalUrl('editCard', {plan: '', period: ''});
    }

    toggleConfirmDowngradeModal = () => this.confirmDowngradeShown = !this.confirmDowngradeShown;

    toggleCancelModal = () => {
        if (this.cancelModalShown) {
            this.cancelModalShown = false;
            this.goDefaultState();
            this.analyticSvc.upgradeShown('downgrade');
        } else {
            this.changeModalUrl('cancel');
        }
    }

    handlerModalClose() {
        this.goDefaultState();
    }

    changeBillingModalCloseHandler() {
        this.changeBillingShown = false;
        this.goDefaultState();
    }

    upgradeModalCloseHandler() {
        this.$scope.upgradeModal.chosen = false;
        this.goDefaultState();
    }

    toggleUpgradeResultModal = (cb = angular.noop) => {
        if (this.upgradeResultShown) {
            this.upgradeResultShown = false;
            this.cbUpgradeResult = cb;
            this.goDefaultState();
        } else {
            this.changeModalUrl('thank-you');
            this.cbUpgradeResult();
        }
    }

    toggleDowngradeResultModal = () => this.downgradeResultShown = !this.downgradeResultShown;

    // toggleUpgradeProjectResultModal = () => {
    //     this.upgradeProjectResultShown = !this.upgradeProjectResultShown;
    //     if (!this.upgradeProjectResultShown) {
    //         this.upgradeOneProjectSvc.updateProjectArgs();
    //     }
    // };

    toggleChangeBilling = () => {
        if (this.isStripe()) {
            this.changeBillingShown = !this.changeBillingShown;

            if (!this.changeBillingShown) {
                this.goDefaultState();
            }
        } else {
            this.changeBillingShowNext = true;
            this.showEditCardDetails();
        }
    }

    hideCardEditSuccess() {
        this.cardEditSuccessShown = false;
        this.openNextModal();
    }

    hideBillingChangeSuccess = () => this.billingChangeSuccessShown = false;

    renewAppSumo() {
        this.changeModalUrl('upgrade', {plan: 'Business', period: 'annual'});
    }

    isErrorRequiredFields(form: ng.IFormController) {
        return form && Object.keys(form.$error).length === 1 && form.$error.required;
    }

    isMonthly() {
        return this.subscriptionDetails.billingPeriod.toLowerCase() === 'monthly';
    }

    getAnnualSave() {
        return this.subscriptionSvc.getAnnualSave();
    }

    getPrice() {
        return this.isMonthlyPeriod() ?
            this.subscriptionSvc.getMonthlyPrice() :
            this.subscriptionSvc.getAnnualPrice();
    }

    updateSubscriptionDetails() {
        this.subscriptionDetails = this.subscriptionSvc.getDetails();
        this.isFree = this.subscriptionSvc.isFree();
        this.isHigh = this.subscriptionSvc.isHigh();
        this.isSpecial = this.subscriptionSvc.isSpecial();
        this.isAppSumo = this.subscriptionSvc.isAppSumo();
        this.couponCompanyName = this.isAppSumo ? this.getCouponCompanyName() : '';
        this.planName = this.getPlanName();
    }

    private changeBillingPeriodRequestHandler(oldPeriod: string) {
        const newPeriod = this.subscriptionDetails.billingPeriod;
        this.analyticSvc.changeBillingPeriod(oldPeriod, newPeriod);
        this.billingChangeSuccessShown = true;
        this.toggleChangeBilling();
    }

    private getPlanName() {
        const {displayName, billingPeriod} = this.subscriptionDetails;
        const period = /coupon/i.test(billingPeriod) ? '' : billingPeriod;
        return `${displayName} ${period}`;
    }

    private getCouponCompanyName() {
        const {displayName, discount: {provider}} = this.subscriptionDetails;
        const dealText = this.TranslateSvc.get('deal');
        const providerInfo = CouponCompaniesNames[provider];
        const providerText = providerInfo ? `- ${providerInfo.title} ${dealText}` : '';

        return `${displayName} ${providerText}`;
    }

    private openNextModal() {
        if (this.changeBillingShowNext) {
            this.changeBillingShown = true;
        }
    }

    private goDefaultState() {
        return this.$state.go(
            this.$state.current,
            {
                modal: '',
                plan: '',
                period: '',
                coupon: ''
            },
            {notify: false}
        );
    }

    private changeModalUrl(modal?: SubscriptionsParamsModal, params: SubscriptionsParams = {}) {
        const {displayName, billingPeriod} = this.subscriptionDetails;

        const extendParams = {
            plan: displayName,
            period: billingPeriod.toLowerCase(),
            ...params
        };

        this.$state
            .go(
                this.$state.current,
                {modal, ...extendParams},
                {notify: false}
            )
            .finally(() => this.openModal({modal, ...extendParams}));
    }

    private addTransaction() {
        if (this.subscriptionSvc.totalPriceLastValue <= 0) return;

        const {displayName, billingPeriod} = this.subscriptionSvc.getDetails();
        const subscriptionName = `${displayName} - ${billingPeriod}`;

        this.analyticSvc.addTransaction(`${this.subscriptionSvc.totalPriceLastValue}`, subscriptionName);
    }

    private openModal(params?: SubscriptionsParams) {
        const {modal, plan} = {...this.$stateParams, ...params} as SubscriptionsParams;
        this.setBillingPeriodScope();
        this.responseError = ''; // remove all previous errors
        this.subscriptionMessageSvc.hideMassage();
        this.isChangeCard = false;

        switch (modal) {
            case 'thank-you': {
                this.upgradedTo = plan;
                this.upgradeResultShown = true;
                break;
            }
            case 'cancel': {
                this.cancelModalShown = true;
                break;
            }
            case 'upgrade': {
                this.openChangeSubscriptionModal('upgrade')
                    .then(() => this.toggleUpgradeModal());
                break;
            }
            case 'downgrade': {
                if (plan === 'Free') {
                    this.toggleCancelModal();
                } else {
                    this.openChangeSubscriptionModal('downgrade')
                        .then(() => this.toggleUpgradeModal());
                }
                break;
            }
            case 'switch-period': {
                this.openChangeSubscriptionModal();
                this.toggleChangeBilling();
                break;
            }
            case 'editCard': {
                this.showEditCard = true;
                break;
            }
        }
    }

    private openChangeSubscriptionModal(action?: anm.UpgradeAction) {
        this.subscriptionPredictPrice = null; // needed for correct works ng-init directive
        return this.subscriptionSvc.findSubscriptionByName(this.$stateParams.plan)
            .then((subscription) => {
                this.subscriptionPredictPrice = subscription;

                if (action) {
                    this.upgradeAction = action;
                }
            });
    }

    private toggleUpgradeModal() {
        if (!this.$scope.upgradeModal) this.$scope.upgradeModal = {};
        this.$scope.upgradeModal.chosen = !this.$scope.upgradeModal.chosen;

        if (!this.$scope.upgradeModal.chosen) {
            this.goDefaultState();
        }
    }

    private getSpecialUpgrades() {
        const specialUpgradeName = this.mapSpecialUpgrades[this.$stateParams.special];
        const specialUpgrade = this.subscriptionSvc.getUpgradesByName(specialUpgradeName);
        const specialUpgrades = [] as anm.SubscriptionDetails[];
        this.$scope.billing.period = 'ANNUAL';
        specialUpgrade && specialUpgrades.push(specialUpgrade);

        return specialUpgrades;
    }

    private isMonthlyPeriod() {
        return this.subscriptionDetails.monthlyPrice && this.subscriptionDetails.billingPeriod
            .toLowerCase()
            .includes('monthly');
    }
}


angular.module('animatronApp.settings').directive('subscription', () => ({
    controllerAs: 'SubscriptionCtrl',
    controller: SubscriptionCtrl
}));

angular.module('animatronApp.settings').directive('subscriptionPage', () => ({
    templateUrl: require('settings/subscription.html')
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/Subscriptions.ts